import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const weaponFocusModule = namespace('weaponFocuses');
let CharactersWeaponFocuses = class CharactersWeaponFocuses extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Weapon Focuses';
    }
    created() {
        this.fetchWeaponFocuses();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.weaponFocuses)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(weaponFocus => ({
            ...weaponFocus,
            id: weaponFocus.name,
            isExpandable: weaponFocus.description
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    weaponFocusModule.State
], CharactersWeaponFocuses.prototype, "weaponFocuses", void 0);
__decorate([
    weaponFocusModule.Action
], CharactersWeaponFocuses.prototype, "fetchWeaponFocuses", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersWeaponFocuses.prototype, "isInHandbook", void 0);
CharactersWeaponFocuses = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersWeaponFocuses);
export default CharactersWeaponFocuses;
